export default __webpack_public_path__ + "static/media/Foyer400.5c8f3033.jpg";